import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mia-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {
  @Input()
  public message: string;
  @Output()
  public confirmed = new EventEmitter();
  @Output()
  public rejected = new EventEmitter();

  private _isLoading: boolean = false;
  public get isLoading(): boolean {
    return this._isLoading;
  }

  public confirm() {
    this._isLoading = true;
    this.confirmed.emit();
  }
  public reject() {
    this._isLoading = true;
    this.rejected.emit();
  }
}
